import { render } from "./SitewideMessage.vue?vue&type=template&id=9b1cbd20"
import script from "./SitewideMessage.vue?vue&type=script&lang=js"
export * from "./SitewideMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__